import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    unknownPosition: translate({ id: 'rm.contextual.positionNA' }),
  }))

  return api
}
